export default [
	{
		luckyWheel: require('@/assets/sound/lucky_wheel/bgm.mp3')
	},
	{
		gameID: 100,
		gameName: '搏一搏小游戏',
		pokerFlip: require('@/assets/sound/small-game/pokerFlip.mp3'),
		mahjongFlip: require('@/assets/sound/small-game/mahjongFlip.mp3'),
		win: require('@/assets/sound/small-game/win.mp3'),
		lose: require('@/assets/sound/small-game/lose.mp3')
	},
	{
		gameID: 999,
		gameName: '壳'
	},
	{
		gameID: 1000,
		gameName: '游戏总大厅',
		hallBgm: require('@/assets/sound/hall/hallBgm.mp3'),
		click: require('@/assets/sound/hall/click.mp3')
	},
	{
		gameID: 1001,
		gameName: '千炮捕鱼王',
		hallBgm: require('@/assets/sound/fish3d/hallBgm.mp3')
	},
	{
		gameID: 1002,
		gameName: '百人推筒子',
		hallBgm: require('@/assets/sound/erba/hallBgm.mp3')
	},
	{
		gameID: 1003,
		gameName: '押庄龙虎',
		hallBgm: require('@/assets/sound/longhu/hallBgm.mp3')
	},
	{
		gameID: 1004,
		gameName: '炸金花',
		hallBgm: require('@/assets/sound/gold/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/gold/roomBgm.mp3')
	},
	{
		gameID: 1005,
		gameName: '通比牌九',
		hallBgm: require('@/assets/sound/domino/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/domino/roomBgm.mp3')
	},
	{
		gameID: 1006,
		gameName: '抢庄牛牛',
		hallBgm: require('@/assets/sound/niuniu/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/niuniu/roomBgm.mp3')
	},
	{
		gameID: 1007,
		gameName: '红黑大战',
		hallBgm: require('@/assets/sound/redblack/hallBgm.mp3')
	},
	{
		gameID: 1008,
		gameName: '十三水',
		hallBgm: require('@/assets/sound/thirteen/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/thirteen/roomBgm.mp3')
	},
	{
		gameID: 1009,
		gameName: '斗地主',
		hallBgm: require('@/assets/sound/ddz/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/ddz/roomBgm.mp3')
	},
	{
		gameID: 1010,
		gameName: '德州扑克',
		hallBgm: require('@/assets/sound/holdem/hallBgm.mp3')
	},
	{
		gameID: 1011,
		gameName: '百家乐',
		hallBgm: require('@/assets/sound/banker/hallBgm.mp3')
	},
	{
		gameID: 1012,
		gameName: '三公',
		hallBgm: require('@/assets/sound/sg/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/sg/roomBgm.mp3')
	},
	{
		gameID: 1013,
		gameName: '跑得快',
		hallBgm: require('@/assets/sound/pdk/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/pdk/roomBgm.mp3')
	},
	{
		gameID: 1014,
		gameName: '急速炸金花',
		hallBgm: require('@/assets/sound/gold_fast/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/gold_fast/roomBgm.mp3')
	},
	{
		gameID: 1015,
		gameName: '二十一点',
		hallBgm: require('@/assets/sound/3dblackjack/hallBgm.mp3')
	},
	{
		gameID: 1016,
		gameName: '欧式轮盘',
		hallBgm: require('@/assets/sound/reel3d/hallBgm.mp3')
	},
	{
		gameID: 1017,
		gameName: '十点半',
		hallBgm: require('@/assets/sound/sdb/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/sdb/roomBgm.mp3')
	},
	{
		gameID: 1018,
		gameName: '捕鱼王中王',
		hallBgm: require('@/assets/sound/1018/hallBgm.mp3')
	},
	{
		gameID: 1019,
		gameName: '百人百家乐',
		hallBgm: require('@/assets/sound/baccarat/hallBgm.mp3')
	},
	{
		gameID: 1020,
		gameName: '百人牛牛',
		hallBgm: require('@/assets/sound/h_niuniu/hallBgm.mp3')
	},
	{
		gameID: 1021,
		gameName: '看牌抢庄牛牛',
		hallBgm: require('@/assets/sound/niuniu_open4/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/niuniu_open4/roomBgm.mp3')
	},
	{
		gameID: 1022,
		gameName: '奔驰宝马',
		hallBgm: require('@/assets/sound/bcbm/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/bcbm/roomBgm.mp3')
	},
	{
		gameID: 1023,
		gameName: '血流成河',
		hallBgm: require('@/assets/sound/mj_blood_river/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/mj_blood_river/hallBgm2.mp3')
	},
	{
		gameID: 1024,
		gameName: '翻倍血流',
		hallBgm: require('@/assets/sound/mj_blood_river/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/mj_blood_river/hallBgm2.mp3')
	},
	{
		gameID: 1025,
		gameName: '二人麻将',
		hallBgm: require('@/assets/sound/mj_blood_river/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/mj_blood_river/hallBgm2.mp3')
	},
	{
		gameID: 1026,
		gameName: '抢红包',
		hallBgm: require('@/assets/sound/slhb/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/slhb/roomBgm.mp3')
	},
	{
		gameID: 1027,
		gameName: '癞子牛牛',
		hallBgm: require('@/assets/sound/1027/roomBgm.mp3'),
		roomBgm: require('@/assets/sound/1027/roomBgm.mp3')
	},
	{
		gameID: 1028,
		gameName: '看三张牛牛',
		hallBgm: require('@/assets/sound/1028/roomBgm.mp3'),
		roomBgm: require('@/assets/sound/1028/roomBgm.mp3')
	},
	{
		gameID: 1030,
		gameName: '前注德州',
		hallBgm: require('@/assets/sound/holdem/hallBgm.mp3')
	},
	{
		gameID: 1031,
		gameName: '急速斗地主',
		hallBgm: require('@/assets/sound/1031/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/1031/roomBgm.mp3')
	},
	{
		gameID: 1046,
		gameName: '海盗捕鱼',
		hallBgm: require('@/assets/sound/pirateFish/hallBgm.mp3')
	},
	{
		gameID: 1047,
		gameName: '美人鱼捕鱼',
		hallBgm: require('@/assets/sound/pirateFish/hallBgm.mp3')
	},
	{
		gameID: 1048,
		gameName: '2D李逵劈鱼',
		hallBgm: require('@/assets/sound/1048/hallBgm.mp3')
	},
	{
		gameID: 1049,
		gameName: '大闹天宫',
		hallBgm: require('@/assets/sound/1049/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/1049/roomBgm.mp3'),
		wukongBgm: require('@/assets/sound/1049/wukong.mp3')
	},
	{
		gameID: 1050,
		gameName: '捕鸟达人',
		hallBgm: require('@/assets/sound/1050/hallBgm.mp3'),
		fenghuangBgm: require('@/assets/sound/1050/fenghuang.mp3')
	},
	{
		gameID: 1051,
		gameName: '金蟾捕鱼',
		hallBgm: require('@/assets/sound/1051/bgm1.mp3'),
		roomBgm: require('@/assets/sound/1051/bgm2.mp3')
	},
	{
		gameID: 1052,
		gameName: '炸金牛',
		hallBgm: require('@/assets/sound/1052/hallBgm.mp3'),
	},
	{
		gameID: 1053,
		gameName: '赌场扑克',
		hallBgm: require('@/assets/sound/1053/hallBgm.mp3'),
	},
	{
		gameID: 1054,
		gameName: '龙王捕鱼',
		hallBgm: require('@/assets/sound/1051/bgm1.mp3'),
		roomBgm: require('@/assets/sound/1051/bgm2.mp3')
	},
	{
		gameID: 1146,
		gameName: 'LX捕鱼',
		hallBgm: require('@/assets/sound/1146/hallBgm.mp3')
	},
	{
		gameID: 1152,
		gameName: '梭哈',
		hallBgm: require('@/assets/sound/1152/hallBgm.mp3')
	},
	{
		gameID: 1301,
		gameName: '看牌抢庄牛牛3D',
		hallBgm: require('@/assets/sound/1301/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/1301/roomBgm.mp3')
	},
	{
		gameID: 1302,
		gameName: '抢庄牛牛3D',
		hallBgm: require('@/assets/sound/1302/hallBgm.mp3'),
		roomBgm: require('@/assets/sound/1302/roomBgm.mp3')
	},
	{
		gameID: 1303,
		gameName: '3D炸金花',
		hallBgm: require('@/assets/sound/1303/hallBgm.mp3')
	},
	{
		gameID: 1401,
		gameName: '圣城风云',
		normal: require('@/assets/sound/1401/slots_arthurs_camelot_ambiance.mp3'),
		king: require('@/assets/sound/1401/slots_arthurs_camelot_ambiance_king.mp3'),
		witch: require('@/assets/sound/1401/slots_arthurs_camelot_ambiance_witch.mp3')
	},
	{
		gameID: 1402,
		gameName: '经典水果机',
		normal: require('@/assets/sound/1402/slots_classic_fruits_ambience.mp3')
	},
	{
		gameID: 1403,
		gameName: '布法罗山谷',
		normal: require('@/assets/sound/1403/bgm.mp3'),
		king: require('@/assets/sound/1403/king.mp3')
	},
	{
		gameID: 1404,
		gameName: '黄金国度',
		normal: require('@/assets/sound/1404/slots_gold_country_ambience.mp3'),
		bonus: require('@/assets/sound/1404/slots_gold_country_old_mine_ambience.mp3')
	},
	{
		gameID: 1405,
		gameName: '足球世界杯',
		normal: require('@/assets/sound/1405/bgm.mp3'),
		king: require('@/assets/sound/1405/king.mp3')
	},
	{
		gameID: 1501,
		gameName: '宝石消消消',
		roomBgm: require('@/assets/sound/1501/hallBgm.mp3')
	},
	{
		gameID: 1601,
		gameName: 'andar bahar',
		hallBgm: require('@/assets/sound/1601/hallBgm.mp3')
	},
	{
		gameID: 1602,
		gameName: 'rummy',
		hallBgm: require('@/assets/sound/1602/hallBgm.mp3')
	},
	{
		gameID: 1603,
		gameName: 'teen patti',
		hallBgm: require('@/assets/sound/1603/hallBgm.mp3')
	},
	{
		gameID: 1604,
		gameName: '7up 7down',
		hallBgm: require('@/assets/sound/1604/hallBgm.mp3')
	},
	{
		gameID: 4001,
		gameName: '好友房',
		hallBgm: require('@/assets/sound/4001/hallBgm.mp3')
	}
];
